import type { InjectionKey } from "vue";

/**
 * Fechar a gaveta do Ben, para quem está DENTRO dela e leva a pessoa a outra tela
 * ("ver o turno"): a rota trocava por baixo da gaveta aberta e o toque parecia não
 * fazer nada (dono, 25/10). Ausente fora da gaveta — a coluna da inbox não fecha.
 */
export const DOCK_CLOSE: InjectionKey<() => void> = Symbol("dock-close");
